module.exports = __webpack_public_path__ + "img/GB.a6caf01a.svg";